import { take } from 'lodash';
import { useState } from 'react';

export const useTruncated = <T>(
  array: T[],
  maxLen = 5,
): {
  rows: T[];
  remainingRows: number;
  shouldShowLoadMore: boolean;
  shouldShowAllRows: boolean;
  showAllRows: () => void;
} => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const rows = !expanded ? take(array, maxLen) : array;
  const remainingRows = array && array.length - rows.length;
  const shouldShowLoadMore = array.length > maxLen;

  const showAllRows = () => {
    setExpanded(!expanded);
  };

  return {
    rows,
    remainingRows,
    shouldShowLoadMore,
    shouldShowAllRows: expanded,
    showAllRows,
  };
};
